module.exports = "https://cdn.hellotech.com/client-assets/universal_remotes_tablet_a55878bdb5f94a66b5b6869f3e40045b.png";